export default "__VITE_ASSET__rLjsPLpK__"